export default "__VITE_ASSET__2054b39b__"